import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDossier: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconDossier"><Path d="M2 6.5C2 5.11929 3.11929 4 4.5 4H8V9H22V17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5Z" fill="currentColor"/><Path d="M9 4H15V8H9V4Z" fill="currentColor"/><Path d="M16 4H19.5C20.8807 4 22 5.11929 22 6.5V8H16V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDossier;
